import { render, staticRenderFns } from "./ImpressumView.vue?vue&type=template&id=2e8ea88e&scoped=true"
import script from "./ImpressumView.vue?vue&type=script&lang=ts"
export * from "./ImpressumView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8ea88e",
  null
  
)

export default component.exports